module.exports = __webpack_public_path__ + "img/Sul.6ea45cc0.svg";